<template>
  <div class="container">
    <div
      class="rule-enter mwow-button-filled success mini"
      @click="toStudentRules"
    >
      <i class="el-icon-setting"></i>规则设置
    </div>
    <el-tabs v-model="activeName" @tab-click="handleTabChange">
      <el-tab-pane label="意向学员" name="latent">
        <tab-latent :visible="activeName === 'latent'"></tab-latent>
      </el-tab-pane>
      <el-tab-pane label="公海池" name="waiting">
        <tab-waiting :visible="activeName === 'waiting'"></tab-waiting>
      </el-tab-pane>
      <el-tab-pane label="回收池" name="recycle">
        <tab-recycle :visible="activeName === 'recycle'"></tab-recycle>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { PageModule } from "@/store/module/page";
import tabLatent from "./latent/index.vue";
import tabRecycle from "./recycle/index.vue";
import tabWaiting from "./waiting/index.vue";
export default {
  components: {
    tabLatent,
    tabRecycle,
    tabWaiting,
  },
  data() {
    return {
      activeName: "latent",
      isCollapse: false,
    };
  },
  created() {
    if (PageModule.latestRoute === "dashboard") {
      // 来自首页
      this.activeName = this.$route.params.tab || "latent";
    } else {
      let pageCache = sessionStorage.getItem("recruit-latent-page-cache");
      if (pageCache) {
        let pageCacheJSON = JSON.parse(pageCache);
        if (pageCacheJSON.tab) {
          this.activeName = pageCacheJSON.tab;
        }
      }
    }
  },
  methods: {
    toStudentRules() {
      this.$router.push({
        name: "approveRule",
        params: {
          tab: "student",
        },
      });
    },
    handleTabChange() {
      sessionStorage.setItem(
        "recruit-latent-page-cache",
        JSON.stringify({
          tab: this.activeName,
        })
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  position: relative;
  /deep/.el-tabs__active-bar {
    transition: none;
  }
  .rule-enter {
    position: absolute;
    top: 10px;
    right: 12px;
    z-index: 1000;
    cursor: pointer;
    i {
      margin-right: 4px;
    }
  }
}
</style>
